import { BASE_DATA_URL } from '../constants';

export const calculateCsvDataUrl = (dataFileName) => {
  return `${ BASE_DATA_URL }${dataFileName}.csv`;
}

export const calculateExcelDataUrl = (dataFileName) => {
  return `${ BASE_DATA_URL }${dataFileName}.xlsx`;
}
